// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__144bV","select":"Header_select__3kauu","clinic":"Header_clinic__3-0kW"};